<template>
    <main>
        <v-container class="grey lighten-4 fill-height" fluid>
                  <v-row>
            <v-col cols="12" md="9">
            <!-- <h1 class="">{{schedule.title}}</h1>
            <div class="mb-5"><v-icon>fa fa-map-marker-alt</v-icon> {{schedule.location}}</div>
            <div><v-icon>fa fa-quote-right</v-icon> {{schedule.description}}</div> -->
            <noifneeded v-bind:store="store" />
            </v-col>
            <!-- <v-container
                style="width:60%" >
                <noifneeded v-bind:store="store" />
            </v-container> -->
            <!-- <v-container style="width:60%" v-else>
                <ifneeded v-bind:store="store" />
            </v-container> -->
            <v-col cols="12" md="3">
                 <v-card class="pa-3">
                <adds :theme="schedule.theme" />
                </v-card>
            </v-col >
        </v-row>  
        </v-container>
    </main>
</template>

<script>
import store from "../../store";
import axios from "axios";
import noifneeded from "./participants/noifneeded";
// import ifneeded from "./participants/ifneeded";
import adds from "../ads";
export default {
    components: {
        noifneeded,
        // ifneeded,
        adds
    },
    data: function() {
        return {
            store: store,
            link: this.$route.params.link,
            schedule: []
        };
    },
    created: async function() {
        var bodyForm = new FormData();
        bodyForm.set("link", this.link);
        var config = {
            method: "post",
            url: `${this.store.state.baseURL}getscheduledetails`,
            headers: {
                "Content-Type": "application/form-data;charset=utf-8",
                "Access-Control-Allow-Origin": "*",
                Accept: "*/*"
            },
            data: bodyForm
        };
        axios(config)
        .then(res =>{
            // console.log(res.data)
            let r = res.data;
        this.schedules = r.schedule,
        this.schedule = r.schedule[0],
        this.dates = r.time,
        this.participants = r.participants,
        this.participant_dates = r.participants_date,
        this.store.state.getSchedule.details = this.schedules,
        this.store.state.getSchedule.dates = this.dates,
        this.store.state.getSchedule.participants = this.participants,
        this.store.state.getSchedule.participantDates = this.participant_dates;
        // this.store.dispatch("getScheduleDetails", config);
        // this.schedule = this.store.state.getSchedule.details[0];
        // this.$forceUpdate()
        // console.log(this.schedule)
        })
    }
};
</script>

<style></style>
